module.exports = __webpack_public_path__ + "static/media/three.8f898e98.png";